import { Components, Theme } from "@mui/material";

export const MuiFormLabel: Components<Omit<Theme, "MuiFormLabel">>["MuiFormLabel"] =
  {
    styleOverrides: {
      root: ({ theme: { palette } }) => ({
        color: palette.text.primary,
      }),
    },
  };
